module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/projects"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Projects")]), _vm._v(" "), (_vm.$route.params.id != 'new') ? _c('nav-tabs', {
    attrs: {
      "classes": "pull-right",
      "tabs": _vm.navTabs
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), (_vm.project) ? _c('h1', [_vm._v(_vm._s(_vm.project.project_name))]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.project) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well project-details"
  }, [(_vm.project.archived == 0) ? _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "position": "absolute",
      "top": "5px",
      "right": "5px"
    },
    on: {
      "click": _vm.editProjectDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), (_vm.project.archived == 1) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n\t\t\t\t\t\tThis project cannot be edited because it is archived.\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.project) ? _c('tbody', [_c('tr', [_c('th', [_vm._v("Status:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.projectStatus))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Current Phase:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentPhase))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Description:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project.description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Created By:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project.created_by_user.first_name) + " " + _vm._s(_vm.project.created_by_user.last_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Date Created:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.createdAt))])]), _vm._v(" "), (_vm.project.project_lead_user) ? _c('tr', [_c('th', [_vm._v("Project Lead:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project.project_lead_user.first_name) + " " + _vm._s(_vm.project.project_lead_user.last_name))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.project.archived == 0) ? _c('button', {
    staticClass: "btn btn-warning block-button",
    on: {
      "click": _vm.archiveProject
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" Archive Project")]) : _c('button', {
    staticClass: "btn btn-info block-button",
    on: {
      "click": _vm.archiveProject
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" Un-Archive Project")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger block-button",
    on: {
      "click": _vm.deleteProject
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Delete Project")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.activeTab == 'tasks') ? _c('div', {
    staticClass: "well"
  }, [_c('h2', [_vm._v("Filter Tasks")]), _vm._v(" "), _c('button-group', {
    attrs: {
      "vertical": "true",
      "buttons": _vm.taskFilter.buttons,
      "full-width": true
    },
    model: {
      value: (_vm.taskFilter.value),
      callback: function($$v) {
        _vm.taskFilter.value = $$v
      },
      expression: "taskFilter.value"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [(_vm.activeTab == 'tasks') ? _c('div', [_c('task-list', {
    attrs: {
      "heading": _vm.taskFilter.value + ' Tasks',
      "owner-type": "project",
      "include-new-button": true,
      "tasks": _vm.filteredTasks,
      "editable": _vm.project.archived == 0
    },
    on: {
      "modelChanged": _vm.fetchProject
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'phases') ? _c('div', [_c('phase-list', {
    attrs: {
      "phases": _vm.project.phases,
      "editable": _vm.project.archived == 0,
      "owner-type": "project"
    },
    on: {
      "phasesChanged": _vm.fetchProject
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'expenses') ? _c('div', [_c('h2', [_vm._v("Project Expenses for " + _vm._s(_vm.$root.userFullName))]), _vm._v(" "), _c('expense-list', {
    attrs: {
      "owner-type": "project"
    }
  })], 1) : _vm._e()])])]) : (_vm.projectNotFound) ? _c('div', [_vm._v("\n\t\t\tProject not found\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.projectDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.projectDialog.title,
      "modal-visible": _vm.projectDialog.visible,
      "confirm-button-text": "Save",
      "button-class": "btn-success"
    },
    on: {
      "confirm": _vm.saveProject,
      "closeModal": function($event) {
        _vm.projectDialog.visible = false
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Project Name",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectDialog.values.project_name),
      expression: "projectDialog.values.project_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.projectDialog.values.project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectDialog.values.project_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Project Description",
      "col-class": "col-md-4"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectDialog.values.description),
      expression: "projectDialog.values.description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.projectDialog.values.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectDialog.values.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Project Lead",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectDialog.values.project_lead_id),
      expression: "projectDialog.values.project_lead_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projectDialog.values.project_lead_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$root.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))])
  }))])], 1) : _vm._e(), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText,
      "button-class": _vm.confirmDialog.buttonClass
    },
    on: {
      "confirm": function($event) {
        _vm.executeDelete(_vm.confirmDialog.parameters)
      },
      "closeModal": function($event) {
        _vm.confirmDialog.visible = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDialog.message) + "\n        ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d55251","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProjectEditor.vue
// module id = 295
// module chunks = 0